export default __webpack_public_path__ + "static/media/scooter-prodcutos-1-mb@2x.6e8b82e3.jpg";